import HashManager from '../common/HashManager';

import FormatCollection from './collections/FormatCollection';
import FormatNavigationView from './views/FormatNavigationView';
import SeeAllLinkView from './views/SeeAllLinkView';

import SubjectCollection from './collections/SubjectCollection';
import SubjectCollectionView from './views/SubjectCollectionView';
import SubjectsViewTemplate from './templates/SubjectsView.html';

class SubjectsPage extends Backbone.View {
    template = SubjectsViewTemplate;

    mediaTypeProperty = 'format';

    initialize() {
        this.$el.html(SubjectsViewTemplate);

        this.formatCollection = new FormatCollection();
        this.subjectCollection = new SubjectCollection();

        this.seeAllLinkView = new SeeAllLinkView({
            collection: this.formatCollection,
            el: this.$('.js-seeAll'),
        });
        this.formatNavigationView = new FormatNavigationView({
            collection: this.formatCollection,
        });

        this.subjectCollectionView = new SubjectCollectionView({
            collection: this.subjectCollection,
            el: this.$('.js-subjects'),
        });

        this.tabPanel = this.$('[role="tabpanel"]');

        this.$formats = this.$('.js-formats');
        this.$formats.html(this.formatNavigationView.el);

        // Set up application state management event handler
        this.listenTo(this.formatCollection, 'format:select', (formatModel) => {
            this.formatCollection.selectMediaTypeByFormat(formatModel);

            let mediaType = formatModel.get('mediaType');
            this.tabPanel.attr('aria-labelledby', `format-${mediaType}-tab`);
            this.tabPanel.attr('id', `format-${mediaType}-panel`);
            this.displaySubjectsByMediaType(mediaType);
            this.setMediaTypeOnPath(mediaType);
        });

        $(window).on('hashchange', () => {
            let initialFormat = this.getInitialFormat();
            initialFormat.trigger('format:select', initialFormat);
        });

        // Trigger initial load
        this.formatCollection.fetch().done(() => {
            let initialFormat = this.getInitialFormat(true);
            initialFormat.trigger('format:select', initialFormat);
        });
    }

    displaySubjectsByMediaType(mediaType) {
        this.subjectCollection.fetch({ data: { mediaType } });
    }

    getInitialFormat(initialLoad = false) {
        // Attempt to locate the desired mediaType if provided on path, eg: /browse#format=ebook
        let activeFormats = _(this.formatCollection.activeFormats());

        let formatFromPath = activeFormats.find(
            (format) => format.get('mediaType') === this.getMediaTypeFromPath()
        );
        var firstFormat = activeFormats.first();

        if (window.OverDrive.isTolinoDevice && initialLoad) {
            firstFormat = activeFormats.find(
                (format) => format.get('mediaType') === 'ebook'
            );
        }

        return formatFromPath || firstFormat;
    }

    getMediaTypeFromPath() {
        return _(HashManager.get(this.mediaTypeProperty) || []).first();
    }

    setMediaTypeOnPath(mediaType) {
        // Clear the # when 'all' is selected
        HashManager.set(
            this.mediaTypeProperty,
            mediaType === 'all' ? [] : mediaType
        );
    }
}

export default SubjectsPage;
